__turbopack_context__.v({
  "asterisk": "CustomCodeConsentNewContent-module-scss-module__N0AQfa__asterisk",
  "layout": "CustomCodeConsentNewContent-module-scss-module__N0AQfa__layout",
  "listSpacing": "CustomCodeConsentNewContent-module-scss-module__N0AQfa__listSpacing",
  "mobileLayout": "CustomCodeConsentNewContent-module-scss-module__N0AQfa__mobileLayout",
});
